import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2, Search, Trophy } from "lucide-react";
import api from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";
import ThemeToggle from "@/components/ThemeToggle";
import { TournamentCard } from "@/components/landing/TournamentCard";

export default function UpcomingEvents() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/public/tournaments/upcoming", { params: { limit: 100 } }).then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, []);
  const shown = useMemo(() => (items || []).filter((t) => `${t.name} ${t.venue || ""} ${t.categories.join(" ")}`.toLowerCase().includes(q.toLowerCase())), [items, q]);
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text)" }}>
      <header className="glass border-b sticky top-0 z-40" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-2">
          <button data-testid="events-logo" onClick={() => nav("/")} className="shrink-0"><BrandLogo height={30} compact /></button>
          <div className="flex items-center gap-2"><ThemeToggle />
            <button data-testid="events-signup" onClick={() => nav("/signup")} className="btn-glow rounded-full px-4 py-2 text-xs sm:text-sm font-bold">Sign up</button></div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-10">
        <button data-testid="events-back" onClick={() => nav("/")} className="text-sm flex items-center gap-2 mb-5" style={{ color: "var(--text-2)" }}><ArrowLeft className="w-4 h-4" /> Home</button>
        <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl">Upcoming <span className="text-primary-c">tournaments</span></h1>
        <div className="relative mt-6 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--text-2)" }} />
          <input data-testid="events-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, venue or category"
            className="w-full rounded-xl glow-border bg-surface pl-9 pr-3 py-2.5 text-sm outline-none" style={{ color: "var(--text)" }} />
        </div>
        {items === null ? <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary-c" /></div>
          : shown.length === 0 ? <div className="py-20 text-center" data-testid="events-empty" style={{ color: "var(--text-2)" }}><Trophy className="w-9 h-9 mx-auto text-primary-c opacity-50 mb-3" />No upcoming tournaments found.</div>
          : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8" data-testid="events-grid">{shown.map((t, i) => <TournamentCard key={t.tournament_id} t={t} i={i % 6} />)}</div>}
      </main>
    </div>
  );
}
